import { getFileUrl } from "@/config/environment";

const AUDIO_ID_FALLBACKS: Record<number, string> = {
    5111: "/155/Project Ex - Tranquility (freetouse.com).mp3",
};

export const getContentAudioUrl = (content: any) => {
    const mediaPath = content?.file_audio_media?.file_path
        || content?.audio_media?.file_path
        || content?.audio?.file_path
        || content?.file_audio?.file_path
        || content?.audioguide_media?.file_path
        || content?.audio_guide_media?.file_path;

    if (mediaPath) return getFileUrl() + mediaPath;

    const directAudio = content?.file_audio || content?.audio || content?.audioguide || content?.audio_guide;
    if (typeof directAudio === "string" && directAudio.startsWith("/")) return getFileUrl() + directAudio;
    if (typeof directAudio === "string" && directAudio.startsWith("http")) return directAudio;

    const audioId = Number(directAudio);
    if (audioId && AUDIO_ID_FALLBACKS[audioId]) return getFileUrl() + AUDIO_ID_FALLBACKS[audioId];

    return undefined;
}
